import React, { Fragment } from "react";

import {
  Grid,
  Segment,
  Divider,
  Header,
  Icon,
  Form,
  Input,
  Menu,
  Checkbox,
  Button,
  Label,
  Modal,
  Message,
  Pagination,


} from "semantic-ui-react";
import "antd/dist/antd.css";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import axios from "axios";
import Select from "react-select";
import Table from "react-bootstrap/Table";
import { reactLocalStorage } from "reactjs-localstorage";
import "react-notifications-component/dist/theme.css";
import "semantic-ui-css/semantic.min.css";
import "@brainhubeu/react-carousel/lib/style.css";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import DateTime from "react-datetime";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import GoogelUser from "./mapGoogel";

import { selectedlanguage } from "../actions";

import { withGoogleMap, GoogleMap, withScriptjs, InfoWindow, Marker } from "react-google-maps";
import { Circle,Polygon } from "react-google-maps";
import { DrawingManager } from "react-google-maps/lib/components/drawing/DrawingManager";
import Geocode from "react-geocode";
import Autocomplete from 'react-google-autocomplete';
import { API_BASE_URL } from "../utils/endpoints";
const { MarkerWithLabel } = require("react-google-maps/lib/components/addons/MarkerWithLabel");
//initMap
Geocode.setApiKey("AIzaSyDIV-I4FCXCL1mlcHpVYsxC-fVX_hY-5xo");
Geocode.enableDebug();
const libraries = ["drawing"];
const google = window.google;
const googleKey = {
  key: "AIzaSyDIV-I4FCXCL1mlcHpVYsxC-fVX_hY-5xo",
  libraries: ['drawing'].join(',')
}
const zoom_Fixed = 4;
const OPTIONS = {
  minZoom: zoom_Fixed - 4,
  maxZoom: zoom_Fixed + 3,
}
const ribbonOpicity = { opacity: 0.8 };
const modEdit = { marginTop: 200, marginLeft: "30%", height: "auto" };
const modEdita = {
  marginTop: 200,
  marginLeft: "25%",
  height: "auto",
  textAlign: "left",
};

const IconTrashDetailsa = {
  marginTop: 30,
  marginLeft: "15%",
  height: "auto",
};

var options = {
  drawingControl: true,
  drawingControlOptions: {
    drawingModes: ["circle"],
  },
  circleOptions: {
    fillColor: `#32CD32`,
    strokeColor: `#000000`,
    fillOpacity: 0.5,
    strokeWeight: 0.6,
    clickable: true,
    editable: true,

    zIndex: 1,
  },
};

var drawingManager;
var all_overlays = [];
var selectedShape;
var colors = ["#1E90FF", "#FF1493", "#32CD32", "#FF8C00", "#4B0082"];
var selectedColor;
var colorButtons = {};
var selectedShape;
const polygonRef = null;
const listenersRef = [];

const modDelete = {
  marginTop: 200,
  marginLeft: "30%",
  height: "auto",
  width: 700,
  textAlign: "left",
};

const modDeletea = {
  marginTop: 200,
  marginLeft: "15%",
  height: "auto",
  width: 700,
  textAlign: "left",
};
const jordanCoords = [

  { lat: 29.357242948788763,lng:34.95949224853514 },
  { lat: 29.18389199055402, lng:36.07316088867186},
  { lat:29.500175899873142 , lng:36.50444464111327},
  { lat: 29.86799153520519, lng:36.753626586914045},

 

  { lat:29.997364197246604 ,lng: 37.50145391845702},
  { lat: 30.33238892992063, lng:37.66532015991209},
  { lat: 30.50061631019436, lng: 37.997126144409165},
  { lat: 31.500166297487983, lng:37.00106100463866},

 
  { lat:31.99629752358287 ,lng:38.99825529479979 },
  { lat:32.23023714181709 , lng:39.30114579391478},
  { lat: 32.3555435854215, lng:39.260081809997544},
  { lat: 32.30411916085719, lng:39.04382538986204},



  { lat: 32.47755937791626, lng:38.98611025238036},
  { lat:32.50159143717092, lng:39.0862686653137},
  { lat:33.37664020542303, lng:38.79659609222411},
  { lat:32.34103760465571, lng: 36.86840367507933},
  {lat:32.3111596976835 , lng: 36.8382831039428},


  {lat:32.32972431781741,lng:36.724894763946516},
  {lat:32.32182705250223,lng: 36.71086208248137},
  {lat:32.332915388050495, lng:36.70073342514036},
  
  {lat:32.345469373518256, lng:36.631554526329026},
  {lat:32.36023432092897, lng:36.50039386940001},
  {lat:32.37012156152168, lng:36.484625798702226},
  {lat:32.379191383579375, lng:36.395852090835554},

  {lat:32.457008173603015, lng:36.311843258380875},
  {lat:32.500632296522085, lng:36.23573494148253},
  {lat:32.52991810229745, lng:36.20132551813124},
  {lat:32.529535488767934, lng:36.2010244746208},

  {lat:32.530261834334404, lng:36.19430885934828},
  {lat:32.52780775572548, lng:36.19010251951216},
  {lat:32.51907177655439, lng:36.17894516611098},
  {lat:32.512464752628226, lng:36.16606992673872},

  {lat:32.51907177655439, lng:36.17894516611098},
  {lat:32.52341408246779, lng:36.15611420297621},
  {lat:32.522488662163575, lng:36.14364665937422},
  {lat:32.52354525302723,lng: 36.140085321903214},

  {lat:32.5255915050095, lng:36.12238747072218},
  {lat:32.5237442700621, lng:36.117876631259904},
  {lat:32.51245570527355, lng:36.078356327533704},
  {lat:32.53691459926388, lng:36.07843742990492},

  {lat:32.558621542410066,lng: 36.07123238039015},
  {lat:32.57793285885938, lng:36.06079922342299},
  {lat:32.58482347682061, lng:36.051126541614515},
  {lat:32.585594574963494,lng: 36.04913161420821},

  {lat:32.58741341786955,lng: 36.04925435972212},
  {lat:32.59074269953818, lng:36.043150288105},
  {lat:32.590834918096014, lng:36.040287734985334},
  {lat:32.59288502772438, lng:36.04003691399096},

  {lat:32.60373781563121, lng:36.033344836950285},
  {lat:32.60479796908531, lng:36.026432749867425},
  {lat:32.612269429062906,lng: 36.023860545873625},
  {lat:32.63807891956443, lng:36.02837466919421},

  {lat:32.65542566503933, lng:36.02726963353155},
  {lat:32.65698652702485, lng:36.02438622438906},
  {lat:32.65778774704546, lng:36.021406324625},
  {lat:32.65795867468653, lng:36.01786309206484},

  {lat:32.66103042718499, lng:36.00494829010962},
  {lat:32.661156186843456, lng:36.00238138163088},
  {lat:32.66018138024382, lng:35.98233190369604},
  {lat:32.662637481388856, lng:35.96598916971682},

  {lat:32.66318067022903, lng:35.96481137913464}, 
  {lat:32.66503945218275, lng:35.96331131929158},
   {lat:32.66782307684001, lng:35.96267634075878}, 
   {lat:32.67076553530109, lng:35.961358671128735},

  {lat:32.6727723030806, lng:35.95892124813793},
   {lat:32.67438366164011,lng:35.957614307343945},
    {lat:32.676579995144046,lng: 35.95524528068302},
     {lat:32.676735082972165,lng: 35.95454485440253}, 

   
     {lat:32.678090101413694,lng: 35.952491993129236}, 
     {lat:32.679851213521275,lng: 35.97229236090182}, 
     {lat:32.68126883259678,lng: 35.971986288249475}, 
     {lat:32.6831653341378,lng: 35.96972816908358}, 
     {lat:32.692754668082, lng: 35.964733595073206},
     {lat:32.69689008272754,lng:  35.9407173963785},
     {lat:32.69729863254009, lng:35.94027952575682},
     {lat:32.69890190635756, lng:35.94059539031981},
     {lat:32.699817605545725,lng: 35.94000057601927},
     {lat:32.69982281292162, lng:35.93922209930418},
     {lat:32.69939326740233,lng :35.9382410469055},
     {lat:32.69953390208137, lng:35.93776297760008},
     {lat:32.70027805529131, lng:35.93736128234862},
     {lat:32.701628484484175, lng:35.93806606721876},
     {lat:32.701887353632806, lng:35.93798087263106},
     {lat:32.70217017882881, lng:35.93805265617369},
     {lat:32.70307681636371,lng: 35.93861655616759},
     {lat:32.70323098739559, lng:35.93864005994795},
     {lat:32.70355530543832, lng:35.93866751813887},
     {lat:32.704409147236284, lng:35.93907189559935},
     
     {lat:32.70470637713591, lng:35.93915568017958},
     {lat:32.708570258250425,lng: 35.93997107172011},
     {lat:32.72048654004693, lng:35.935112955093366},
     {lat:32.72221889100152,lng: 35.91954336786269},
     {lat:32.723447136385566, lng:35.911938669204694},
     {lat:32.719330465714876, lng:35.904351336002335},
     {lat:32.72373596979006, lng:35.905673028945905},
     {lat:32.7181750694048, lng:35.89842901849745},
     {lat:32.71767027182483,lng: 35.88258457374571},
     {lat:32.731389021177705,lng: 35.87705717706679},
     {lat:32.731028703175625,lng: 35.85537624549864},
     {lat:32.7292951375434, lng:35.8528529229164},
     {lat:32.726552046451495,lng: 35.85657787513731},
     {lat:32.724818393767166,lng: 35.854397875308976},
     {lat:32.72757194971199,lng: 35.851739170074445},
     {lat:32.73059028257637, lng:35.847796958923325},
     {lat:32.73183195045331, lng:35.84470105361937},
     {lat:32.72991337985417, lng:35.84189609909056},
     {lat:32.72836620257721, lng:35.841267826080305},
     {lat:32.726591969347936,lng: 35.83524422073363},
     {lat:32.73370917429265, lng:35.82633328628538},
     {lat:32.73612264146474, lng:35.810353321075425},
     {lat:32.739160119422436,lng: 35.80925297927855},
     {lat:32.74085149820064, lng:35.81065372848509},
     {lat:32.74183132179559, lng:35.80865216445921},
     {lat:32.7409236925419, lng:35.80674843215941},
     {lat:32.736669331556165,lng: 35.804789783477766},
     {lat:32.73651973068863,lng: 35.8005686225891},
     {lat:32.74273373693388,lng: 35.798781635284406},
     {lat:32.74388361017128,lng: 35.794646305084214},
     {lat:32.748400695073926, lng:35.80024075698851},
     {lat:32.75535236219647, lng:35.79668478393553},
     {lat:32.74739005379123,lng:35.78674388122557},
     {lat:32.74640126759209, lng:35.76484159851073},
     {lat:32.744863400423405, lng:35.756102325439436},
     {lat:32.731528912512545, lng:35.74707464599608},
     {lat:32.72999078867099, lng:35.74228358459471},
     {lat:32.73297293926876, lng:35.73840574645995},
     {lat:32.732878868624425, lng:35.73679042053221},
     {lat:32.72914621722187,lng: 35.73677496337889},
     {lat:32.727896872193945,lng: 35.73473048400877},
     {lat:32.7230808872961,lng: 35.73265509033202},
     {lat:32.72305901502492,lng: 35.7294948120117},
     {lat:32.72633022249916, lng:35.729221862792954},
     {lat:32.72666938104876, lng:35.72554660034178},
     {lat:32.72235879672576, lng:35.72407202148436},
     {lat:32.723997724254644,lng: 35.71945262145994},
     {lat:32.715137569425096,lng: 35.715746444702134},
     {lat:32.718798595091556, lng:35.71078372192381},
     {lat:32.71383768641658,lng: 35.706219238281236},
     {lat:32.715910059024566, lng:35.70323062133787},
     {lat:32.71246556713448, lng:35.6986661376953},
     {lat:32.70919385107975, lng:35.68726611328123},
     {lat:32.70531576202337, lng:35.67540602111815},
     {lat:32.702116009542294, lng:35.67705226135252},
     {lat:32.69563733545448,lng: 35.674290222167954},
     {lat:32.693665198204826, lng:35.67104411315916},
     {lat:32.68586756081039, lng:35.67516998672484},
     {lat:32.68478014924521, lng:35.671215774536115},
     {lat:32.6800882630164, lng:35.66186623001097},
     {lat:32.68478014924521, lng:35.65894198608397},
     {lat:32.67755970262961, lng:35.64487175369261},
     {lat:32.686535767995345,lng: 35.634808105468736},
     {lat:32.67849506857149, lng:35.62615466308592},
     {lat:32.6777222550929, lng:35.62038854980467},
     {lat:32.680373414882496, lng:35.61722827148436},
     {lat:32.675265875217434, lng:35.60717062377928},
     {lat:32.66939175383704, lng:35.603838684082014},
     {lat:32.66905237756802, lng:35.59927420043944},
     {lat:32.65204954082403, lng:35.606585266113264},
     {lat:32.64766308284541, lng:35.564255279541},
     {lat:32.63672778749984, lng:35.56126666259764},
     {lat:32.63349708507235,lng: 35.56803182983397},
     {lat:32.5973995841451,lng: 35.56744647216795},
     {lat:32.59705993470585,lng: 35.57901815795897},
     {lat:32.56586671793416,lng: 35.57225299072264},
     {lat:32.55626745309289,lng: 35.57695822143553},
     {lat:32.54908324157012,lng: 35.568819763183576},
     {lat:32.527035902647235, lng:35.564255279541},
     {lat:32.51463835320666, lng:35.55302691650389},
     {lat:32.50155907290892, lng:35.559448760986314}


 
];

class Map extends React.Component {
  constructor() {
    super();
    this.state = {
      data: [],
      totalPages: "",
      serachTotalPage: "",
      searchWord: "",
      modalDelete: false,
      area_id: "",

      ///////////////new//////////////////
      intervalId: 0,
      ////////////////////////////////////

      visibleWarning: false,
      modalOpenUpload: false,
      areaname: "",
      map: null,
      path: [],
      isArabic: false,
      isDrawing: false,
      shapes: [],
      drawingModes: ["circle"],
      address: '',
      city: '',
      area: '',
      state: '',
      zoom: 15,
      height: 400,
      mapPosition: {
        lat: 0,
        lng: 0,
      },
      markerPosition: {
        lat: 0,
        lng: 0,
      },
      circleData: [],
      pathCircle: [],
      place: [],
      results: [],
      address_components: [],
      editData: [],
      area_name: "",
      modalOpenDelete: false,
      circle_index: "",
    };
    this.handleOverlayComplete = this.handleOverlayComplete.bind(this);
    this.deleteShapes = this.deleteShapes.bind(this);
    this.deleteShapes = this.deleteShapes.bind(this);
    this.clearSelection = this.clearSelection.bind(this);
    this.setSelection = this.setSelection.bind(this);
    this.deletSelectedSahape = this.deletSelectedSahape.bind(this);


    this.input = React.createRef();
    ////////////////////////////////////

  }

  handleOpenDelteArea = () => this.setState({ modalDelete: true });
  handleCloseDelteArea = () => this.setState({ modalDelete: false });

  handleOpenUpload = () => {
    if (this.state.circleData.length > 0) {
      this.setState({ modalOpenUpload: true });
    }
  };
  handleCloseUpload = () => this.setState({ modalOpenUpload: false });

  handleOpenDelete = () => this.setState({ modalOpenDelete: true });
  handleCloseDelete = () => this.setState({ modalOpenDelete: false });


  ////////////new///////////
  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  scrollToTop = () => {
    let intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({ intervalId: intervalId });
  }

  handleScroll = () => {
    window.scroll({
      top: document.body.offsetHeight,
      left: 0,
      behavior: 'smooth',
    });
  }

  //////////////////////////

  componentDidMount() {
    options = {
      drawingControl: false,
      drawingControlOptions: {
        drawingModes: [],
      },
      circleOptions: {
        fillColor: `#32CD32`,
        strokeColor: `#000000`,
        fillOpacity: 0.5,
        strokeWeight: 0.6,
        clickable: true,
        editable: true,

        zIndex: 1,
      },
    };
    this.MapcomponentDidMount();
    reactLocalStorage.get("authenticated");
    reactLocalStorage.get("accessToken");
    this.setState({ modalIsOpen: true });
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true })
      document.querySelector(".main_div_loading").style = "direction:rtl";
      //      document.querySelector(".menu_header").style = "margin-right:14%";
      document.querySelector(".ant-menu").style = "text-align:right";
      document.querySelector(".blue_color").style =
        "direction: rtl;float: right;";
      document.querySelector(".fixed_profile").style =
        "margin-right: 0% !important;";
    }

    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/loadbytokken";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/user/loadbytokken";
    }

    var headers = { "Content-Type": "application/json", tokken: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.ErrorResutl) {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: res.data.result.ErrorResutl,
          animation: "bounce",
          time: 5000,
        });
        window.location = "/app";
      }
    });
    reactLocalStorage.get("user_id_login");
    var lang = i18n.language;
    if (lang === "ar") {
      document.querySelector(".blue_color").style =
        "text-align:right;width: 20%;white-space: pre;";
      //document.querySelector(".profile_add_card").style = "text-align:right";
    }

    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/general/searchPredefinedArea?area_name=&page=0`;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/general/searchPredefinedArea?area_name=&page=0`;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.status === 200) {
        if (res.data.status === "success") {
          if (res.data.result.area !== undefined) {
            var total = Math.ceil(res.data.result.count / 20);

            this.setState({
              data: res.data.result.area,
              totalPages: total,
            });
          }
        }
      }
    });
  }

  handlePaginationChange = (e, { activePage }) => {
    var token = reactLocalStorage.get("accessToken");
    this.setState({ activePage });
    var page_num = activePage - 1;
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/general/searchPredefinedArea?area_name=&page=${page_num}`;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/general/searchPredefinedArea?area_name=&page=${page_num}`;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.status === 200) {
        if (res.data.status === "success") {
          if (res.data.result.area !== undefined) {
            var total = Math.ceil(res.data.result.count / 20);

            this.setState({
              data: res.data.result.area,
              totalPages: total,
            });
          }
        }
      }
    });
  };

  searchchange = (event) => {
    if (event.target.value.length >= 2) {
      document.querySelector(".pagination").style = "display:none";
      document.querySelector(".searchpagination").style = "display:block";
      var token = reactLocalStorage.get("accessToken");

      var searchQuery = event.target.value;
      this.setState({ searchWord: searchQuery });
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl = API_BASE_URL + `/core/user/rest/general/searchPredefinedArea?area_name=${searchQuery}&page=0`;
      } else {
        apiBaseUrl =
          API_BASE_URL +
          `/core/user/rest/general/searchPredefinedArea?area_name=${searchQuery}&page=0`;
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
        if (res.data.result.area != undefined) {
          var total = Math.ceil(res.data.result.count / 20);

          this.setState({
            data: res.data.result.area,
            serachTotalPage: total,
          });
        }
      });
    }
  };

  handlePaginationChangeSearch = (e, { activePage }) => {
    var token = reactLocalStorage.get("accessToken");
    this.setState({ activePage });
    var page_num = activePage - 1;
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var searchQuery = this.state.searchWord;
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/general/searchPredefinedArea?area_name${searchQuery}=&page=${page_num}`;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/general/searchPredefinedArea?area_name=${searchQuery}=&page=${page_num}`;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.status === 200) {
        if (res.data.status === "success") {
          if (res.data.result.area !== undefined) {
            var total = Math.ceil(res.data.result.count / 20);

            this.setState({
              data: res.data.result.area,
              serachTotalPage: total,
            });
          }
        }
      }
    });
  };

  openDelete = (event) => {
    var id = event.target.id;
    this.setState({ area_id: id, modalDelete: true });
  };

  DeleteArea() {
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var area_id = this.state.area_id;
    var body = {
      area_id: area_id
    }
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/general/deletePredefinedArea/${area_id}`;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/general/deletePredefinedArea/${area_id}`;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, {}, { headers: headers }).then((res) => {
      if (res.status === 200) {
        if (res.data.status === "success") {
          window.location = "Map";
        } else {
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      }
    });
  }

  ///////////////////////////////////////////////////////////////////////////////////////////

  /* handleOverlayComplete(e) {
    const shape = e.overlay;
    shape.type = e.type;

    window.google.maps.event.addListener(shape, "click", () => {
      this.toggleSelection(shape);
    });
    this.toggleSelection(shape);
    this.state.shapes.push(shape);
  } */

  /* toggleSelection(shape) {
    if (shape.getEditable() === true) shape.setEditable(false);
    else shape.setEditable(true);
  } */
  handleOverlayComplete(e) {
    const newshape = e.overlay;
    newshape.type = e.type;

    window.google.maps.event.addListener(newshape, "click", () => {
      this.setSelection(newshape);
    });
    this.setSelection(newshape);
    this.state.shapes.push(newshape);
  }
  clearSelection() {
    if (selectedShape) {
      selectedShape.setEditable(false);
      selectedShape = null;
    }
  }
  setSelection(shape) {
    this.clearSelection();
    selectedShape = shape;
    shape.setEditable(true);
  }

  deletSelectedSahape = (index) => {
    if (selectedShape) {
      var index = this.state.circleData.indexOf(selectedShape);
      this.state.circleData.splice(index, 1);
      console.log("allahapes after removing one", this.state.circleData);
      selectedShape.setMap(null);
    }
  };

  deletSelectedSahapeUpdate = (index) => {
    this.setState({ circle_index: index });

    this.setState({ modalOpenDelete: true });
  };

  deleteShapes() {
    var array = [];
    this.setState({ circleData: array });
    this.state.shapes.forEach((shape) => shape.setMap(null));
    console.log(this.state.circleData);
  }

  deleteShapes() {
    var array = [];
    this.setState({ circleData: array });
    this.state.shapes.forEach((shape) => shape.setMap(null));
    console.log(this.state.circleData);
  }

  noDraw = () => {
    this.setState(function set(prevState) {
      return Object.assign({}, prevState, {
        drawingMode: "maker",
      });
    });
  };

  onCircleComplete = function onCircleComplete(circle) {

    if (reactLocalStorage.get("edit") === 'true') {
      // document.querySelector(".upload").style="display:none";
    }
    // document.querySelector(".upload").style="display:block";
    
    console.log(circle);
    const circlelat = circle.getCenter().lat();
    const circleLang = circle.getCenter().lng();
    const radius = circle.radius;
    var Radius = radius / 1000
    const circlesArray = [];
    var Object = { long: circleLang, lat: circlelat, radius: Radius };
    console.log("Object", Object);
    console.log(circleLang, circlelat, radius);

    var jordanArea = new window.google.maps.Polygon({paths: jordanCoords,});
    console.log(window.google.maps.geometry.poly.containsLocation( { lat: circlelat, lng:circleLang },jordanArea));
window.google.maps.geometry.poly.containsLocation( { lat: circlelat, lng:circleLang }, jordanArea)?console.log("IN"):console.log("OUT");

if(window.google.maps.geometry.poly.containsLocation( { lat: circlelat, lng:circleLang }, jordanArea)==false){
  circle.setMap(null)
}else if(window.google.maps.geometry.poly.containsLocation( { lat: circlelat, lng:circleLang },jordanArea)==true){
  if (Radius > 5) {
    document.getElementById("testradius").style = "display:block";
   // circle.setMap(null);
    setTimeout(this.myFunctiontestradius, 5000);

/***********to change color of circle to red if radius > 5km */
circle.setOptions({
fillColor: '#FF2E2E',
strokeColor: '#D10000'
});

/*********** clear circle from map if radius > 5km */

setTimeout(function() {
circle.setMap(null)
}, 3000);
    
  } else {
    if (this.state.circleData.length < 15) {
      //////////new//////////

      //////////new//////////
      this.state.circleData.push(Object);
      this.setState({ drawingModes: circlesArray })
    } else {
      console.log("over");
      document.getElementById("test").style = "display:block";
      circle.setMap(null);
      setTimeout(this.myFunctiontest, 5000);
    }
  }

}

  

    //this.state.circleData.push(Object)
    console.log(this.state.circleData);
    //circlesArray.push(Object)
    //console.log("circlesArray",circlesArray)
    //this.noDraw();
    //drawingManager.setDrawingMode(null);
    //circle.setMap(null)
  };

  myFunctiontest() {
    document.getElementById("test").style = "display:none";
  }

  myFunctiontestradius() {
    document.getElementById("testradius").style = "display:none";
  }

  circleSubmit = () => {
    if (this.state.circleData.length > 0) {
      var token = reactLocalStorage.get("accessToken");
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      var data = {
        area: this.state.circleData,
        area_name: this.state.areaname,
      };
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/general/createOrUpdatePredefinedArea";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/general/createOrUpdatePredefinedArea";
      }
      var headers = {
        token: token,
      };
      axios
        .post(apiBaseUrl, data, { headers: headers })
        .then(function (response) {
          if (response.status === 200) {
            if (response.data.result != undefined) {
              if (response.data.status === "success") {
                window.location = "Map";
              } else {
                toast({
                  type: "warning",
                  title: i18n.t("warning.label"),
                  description: response.data.result.ErrorDescription,
                  animation: "bounce",
                  time: 5000,
                });
              }
            }
          } else if (response.status === 204) {
            console.log("Something wrong");
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000,
            });
          } else {
            console.log("Something wrong");
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000,
            });
          }
        });
    } else {
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: "You must define the region",
        animation: "bounce",
        time: 5000,
      });
    }
  };

  onLoad = (polygon) => {
    /*     polygonRef.current = polygon;
      const path = polygon.getPath();
      listenersRef.current.push(
        path.addListener("set_at", this.onEdit.bind(this)),
        path.addListener("insert_at",  this.onEdit.bind(this)),
        path.addListener("remove_at", this.onEdit.bind(this))
      ); */
  };
  //////////////////////////////////////////

  //////////////////////////////////////////
  ///NOT :                               ///
  /////////////////////////////////////////
  onUnmount = () => {
    //listenersRef.current.forEach(listener=>listener.remove())
    //polygonRef.current=null
  };

  MapcomponentDidMount() {
    var array = []
    this.setState({ circleData: array })
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.setState({
          mapPosition: {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          },
          markerPosition: {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }
        },
          () => {
            Geocode.fromLatLng(position.coords.latitude, position.coords.longitude).then(
              response => {
                console.log(response)
                const address = response.results[0].formatted_address,
                  addressArray = response.results[0].address_components,
                  city = this.getCity(addressArray),
                  area = this.getArea(addressArray),
                  state = this.getState(addressArray);
                console.log('city', city, area, state);
                this.setState({
                  address: (address) ? address : '',
                  area: (area) ? area : '',
                  city: (city) ? city : '',
                  state: (state) ? state : '',
                })
              },
              error => {
                console.error(error);
              }
            );

          })
      });
    } else {
      console.error("Geolocation is not supported by this browser!");
    }
  }

  /* shouldComponentUpdate(nextProps, nextState) {
    if (
      this.state.markerPosition.lat !== this.lat ||
      this.state.address !== nextState.address ||
      this.state.city !== nextState.city ||
      this.state.area !== nextState.area ||
      this.state.state !== nextState.state
    ) {
      return true;
    } else if (this.lat === nextProps.lat) {
      return false;
    }
  } */

  getCity = (addressArray) => {
    let city = '';
    for (let i = 0; i < addressArray.length; i++) {
      if (addressArray[i].types[0] && 'administrative_area_level_2' === addressArray[i].types[0]) {
        city = addressArray[i].long_name;
        return city;
      }
    }
  };

  getArea = (addressArray) => {
    let area = '';
    for (let i = 0; i < addressArray.length; i++) {
      if (addressArray[i].types[0]) {
        for (let j = 0; j < addressArray[i].types.length; j++) {
          if ('sublocality_level_1' === addressArray[i].types[j] || 'locality' === addressArray[i].types[j]) {
            area = addressArray[i].long_name;
            return area;
          }
        }
      }
    }
  };

  getState = (addressArray) => {
    let state = '';
    for (let i = 0; i < addressArray.length; i++) {
      for (let i = 0; i < addressArray.length; i++) {
        if (addressArray[i].types[0] && 'administrative_area_level_1' === addressArray[i].types[0]) {
          state = addressArray[i].long_name;
          return state;
        }
      }
    }
  };

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onInfoWindowClose = (event) => { };

  onMarkerDragEnd = (event) => {
    let newLat = event.latLng.lat(),
      newLng = event.latLng.lng();

    Geocode.fromLatLng(newLat, newLng).then(
      response => {
        const address = response.results[0].formatted_address,
          addressArray = response.results[0].address_components,
          city = this.getCity(addressArray),
          area = this.getArea(addressArray),
          state = this.getState(addressArray);
        this.setState({
          address: (address) ? address : '',
          area: (area) ? area : '',
          city: (city) ? city : '',
          state: (state) ? state : '',
          markerPosition: {
            lat: newLat,
            lng: newLng
          },
          mapPosition: {
            lat: newLat,
            lng: newLng
          },
        })
      },
      error => {
        console.error(error);
      }
    );
  };

  onPlaceSelected = (place) => {
    console.log('plc', place);
    const address = place.formatted_address,
      addressArray = place.address_components,
      city = this.getCity(addressArray),
      area = this.getArea(addressArray),
      state = this.getState(addressArray),
      latValue = place.geometry.location.lat(),
      lngValue = place.geometry.location.lng();

    console.log('latvalue', latValue)
    console.log('lngValue', lngValue)

    // Set these values in the state.
    this.setState({
      address: (address) ? address : '',
      area: (area) ? area : '',
      city: (city) ? city : '',
      state: (state) ? state : '',
      markerPosition: {
        lat: latValue,
        lng: lngValue
      },
      mapPosition: {
        lat: latValue,
        lng: lngValue
      },
    })
  };


  openEdit = (event) => {
    document.querySelector(".update").style = "display:block";
    // document.querySelector(".upload").style = "display:none";
    document.getElementById("area").style = "display:block";
    reactLocalStorage.set("edit", true)
    options = {
      drawingControl: true,
      drawingControlOptions: {
        drawingModes: ["circle"],
      },
      circleOptions: {
        fillColor: `#32CD32`,
        strokeColor: `#000000`,
        fillOpacity: 0.5,
        strokeWeight: 0.6,
        clickable: true,
        editable: true,
        zIndex: 1,
      },
    };

    var id = event.target.id;
    this.setState({ area_id: id });
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/general/searchPredefinedArea?area_name=&page=-1`;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/general/searchPredefinedArea?area_name=&page=-1`;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.status === 200) {
        if (res.data.status === "success") {
          if (res.data.result.area !== undefined) {
            var i;
            var array;
            for (i = 0; i < res.data.result.area.length; i++) {
              if (res.data.result.area[i].id === id) {
                array = res.data.result.area[i].area;
                this.setState({ area_name: res.data.result.area[i].area_name });
              }
            }

            this.setState({ circleData: array });
            console.log(array);
            var j;

            for (j = 0; j < this.state.circleData.length; j++) {
              this.state.circleData[j].circle = {
                radius: this.state.circleData[j].radius,
              };
            }
          }
        }
      }
    });

    ////////////new/////////////
    this.scrollToTop();
    ///////////////////////////
  };

  handleOpenUpdate = () => {

    if (this.state.circleData.length > 0) {
      var token = reactLocalStorage.get("accessToken");
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      var data = {
        area: this.state.circleData,
        area_name: this.state.area_name,
        id: this.state.area_id,
      };
      toast({
        type: "success",
        title: i18n.t("success.label"),
        description: "This area has been successfully updated.",
        animation: "bounce",
        time: 8000
      });
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/general/createOrUpdatePredefinedArea";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/general/createOrUpdatePredefinedArea";
      }
      var headers = {
        token: token,
      };
      axios
        .post(apiBaseUrl, data, { headers: headers })
        .then(function (response) {
          if (response.status === 200) {
            if (response.data.result != undefined) {
              if (response.data.status === "success") {
                window.location = "Map";
              } else {
                toast({
                  type: "warning",
                  title: i18n.t("warning.label"),
                  description: response.data.result.ErrorDescription,
                  animation: "bounce",
                  time: 5000,
                });
              }
            }
          } else if (response.status === 204) {
            console.log("Something wrong");
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000,
            });
          } else {
            console.log("Something wrong");
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000,
            });
          }
        });
    } else {
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: "You cannot keep the region free of areas, at least you should keep one area or remove the regoin from the table .",
        animation: "bounce",
        time: 9000,
      });
    }
  };

  handleOpenDelteUpdate = () => {
    this.state.circleData.splice(this.state.circle_index, 1);
    this.handleOpenUpdate();
  };

  render() {
    const { selectedOption } = this.state;
    const { visibleWarning } = this.state;
    const MapWithAMarker = withScriptjs(
      withGoogleMap((props) => (
        <GoogleMap
          zoom={6}
          google={this.props.google}

          // options = {OPTIONS}
        
          minZoom={6}
          a
          //  // defaultCenter={{ lat: this.state.mapPosition.lat, lng: this.state.mapPosition.lng }}
          defaultCenter={{ lat: this.state.mapPosition.lat, lng: this.state.mapPosition.lng }}

          onClick={this.clearSelection}
          mapContainerClassName={"map-style"}
        >
          {/*9-8-2023 */}
          {/* 
           <Marker
            google={this.props.google}
            name={'Dolores park'}
            draggable={true}
            onDragEnd={this.onMarkerDragEnd}
            position={{ lat: this.state.markerPosition.lat, lng: this.state.markerPosition.lng }}
          />
          <InfoWindow
            onClose={this.onInfoWindowClose}
            position={{ lat: (this.state.markerPosition.lat + 0.013), lng: this.state.markerPosition.lng }}
          >
            <div>
              <span style={{ padding: 0, margin: 0 }}>{this.state.address}</span>
            </div>
          </InfoWindow>
          <Marker />
          */}
         
          {/* <MarkerWithLabel
                            position={{ lat: -34.397, lng: 150.644 }}
                            labelAnchor={new google.maps.Point(0, 0)}
                            labelStyle={{ backgroundColor: "yellow", fontSize: "32px", padding: "16px" }}
                        >
                            <div>Hello There!</div>
                        </MarkerWithLabel> */}


          {/* For Auto complete Search Box */}
          <Autocomplete
            style={{
              width: '50%',
              height: '40px',
              paddingLeft: '16px',
              marginTop: '-340px',
              marginBottom: '2rem',
              position: 'absolute',
              marginLeft: '10px'

            }}
            onPlaceSelected={this.onPlaceSelected}
            types={['(regions)']}
          />
           <Polygon
                          options={{
                            fillColor: `#BBD2EC`,
                            strokeColor: `#3E77B6`,
                            fillOpacity: 0.45,
                            strokeWeight: 2,
                            strokeOpacity:0.8
                          }}
                        
                     
                          ref={this.refPoly}
                              editable={false}
                              draggable={false}
                              path={jordanCoords}
                             
                            />

          {this.state.path.length === 0 ? (
            <DrawingManager
              drawingMode={this.state.drawingMode}
              options={options}
              onCircleComplete={this.onCircleComplete.bind(this)}
              editable={false}
              draggable={false}
              onOverlayComplete={this.handleOverlayComplete}
            />
          ) : (
            <Circle
              options={{
                fillOpacity: 0.45,
                strokeWeight: 0,
              }}
              draggable={true}
              editable={true}
              path={this.state.path}
              onMouseUp={this.onEdit}
              onDrag={this.onDrag}
              onDragEnd={this.onDrag}
              onLoad={this.onLoad}
              onUnmount={this.onUnmount}
              defaultRadius={2000}
            />
          )}

          {this.state.circleData.map((place, index) => {
            return (
              <Fragment key={index}>
                <Marker
                  position={{
                    lat: parseFloat(place.lat),
                    lng: parseFloat(place.long),
                  }}
                >
                  <InfoWindow
                    onClose={this.onInfoWindowClose}
                    position={{
                      lat: place.lat,
                      lng: place.long,
                    }}
                  >
                    <div>
                      <span style={{ padding: 0, margin: 0 }}>
                        <label style={{ width: "60px", color: "red" }}>
                          {" "}
                          Circle:
                        </label>{" "}
                        {index}
                        <br />
                        <label style={{ width: "60px", color: "red" }}>
                          {" "}
                          latitude:
                        </label>{" "}
                        {place.lat}
                        <br />
                        <label style={{ width: "60px", color: "red" }}>
                          {" "}
                          longitude:
                        </label>{" "}
                        {place.long}
                        <br />
                        <label style={{ width: "60px", color: "red" }}>
                          {" "}
                          Radius:
                        </label>{" "}
                        {place.radius} Km
                      </span>
                    </div>
                  </InfoWindow>
                </Marker>

                <Circle
                  onClick={
                    (reactLocalStorage.set("edit", true),
                      () => {
                        this.deletSelectedSahapeUpdate(index);
                      })
                  }
                  path={this.state.path}
                  onMouseUp={this.onEdit}
                  onDragEnd={this.onEdit}
                  onLoad={this.onLoad}
                  onUnmount={this.onUnmount}
                  defaultCenter={{
                    lat: parseFloat(place.lat),
                    lng: parseFloat(place.long),
                  }}
                  radius={place.radius * 1000}
                  options={{

                    fillColor: `#32CD32`,
                    strokeColor: `#000000`,
                    strokeWeight: 0.6,
                  }

                  }
                />
              </Fragment>
            );
          })}

          {this.state.path.map((pos, key) => {
            console.log(pos);
            return <Marker key={key} label={"" + key} position={pos} />;
          })}
        </GoogleMap>
      ))
    );

    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_request">
            <div className="main_request">
              <Grid columns={2} divided className="fixed_profile">
                <Grid.Row stretched className="fixed_header">
                  <Grid.Column className="grid_logo ">
                    <Segment>
                      <h3 className="text_style blue_color">
                        {reactLocalStorage.get("lang") === "ar" ? (
                          <img
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>

          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />
              <Segment
                color="black" basic
                style={{ padding: "20px", minHeight: "200px" }}
              >
                <br />

                <Divider horizontal>
                  {" "}
                  <Header as="h2" color="black">
                    <Icon name="map marker outline" color="black" /> {this.state.isArabic ? 'المناطق على الخريطة' : 'Regions on Map'}{" "}
                  </Header>{" "}
                </Divider>
                <br />
                <div className="buttonsHeader">
                  <Input
                    size="small"
                    icon="search"
                    placeholder={
                      this.state.isArabic
                        ? "البحث عن اسم المنطقة"
                        : "Search By Region Name"
                    }
                    color="black"
                    onChange={this.searchchange.bind(this)}
                    style={{ float: "right" }}
                  />

                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.deleteShapes}
                  >
                    <Icon name="trash alternate" />{this.state.isArabic ? "حذف جميع المساحات" : ' Delete All Area'}
                  </Button>

                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={() => { window.location = "AddArea" }}
                  >
                    <Icon name="pencil" /> {this.state.isArabic ? 'إضافة منطقة جديدة' : 'Add New Region'}
                  </Button>

                  {/* <div className="upload" style={{ display:"none"}}>
                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.handleOpenUpload}
                  >
                    <Icon name="upload" /> Upload Area
                  </Button>
                  </div>
 */}
                  <div className="update" style={{ display: "none" }}>
                    <Button
                      floated="right"
                      icon
                      labelPosition="left"
                      basic
                      size="small"
                      onClick={this.handleOpenUpdate}
                    >
                      <Icon name="redo alternate" /> {this.state.isArabic ? 'تعديل' : 'Update'}
                    </Button>
                  </div>
                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.handleScroll}
                  >
                    <Icon name="point" /> {this.state.isArabic ? 'المناطق' : 'Regions'}
                  </Button>
                </div>

                <br />
                <br />

                {/*  <Message icon error>
                  <Icon name="warning sign" loading />

                  <Message.Content>
                    <Message.Header>
                      There are a some things you should pay attention to when
                      drawing on the map !
                    </Message.Header>

                    <Message.List>
                      <Message.Item>
                        When drawing the circle, the coordinates are stored for
                        the first time, and their size will not be modified.
                      </Message.Item>

                      <Message.Item>
                        When drawing the circle, you cannot change its location.
                      </Message.Item>
                    </Message.List>
                  </Message.Content>
                </Message> */}

                <div id="area" style={{ display: "none" }}>
                  <Message icon>
                    <Icon name='map' />
                    <Message.Content>
                      <Message.Header>Region Information</Message.Header>
                      The ( {this.state.area_name} ) region information is displayed on the map. You can add a new area or delete an area and Update changes.
                    </Message.Content>
                  </Message>
                </div>
                <div id="test" style={{ display: "none" }}>
                  <Message
                    warning
                    icon="warning circle"
                    header="Warning!"
                    content=" We are sorry you can not draw more than 15 area circles !"
                  />
                </div>
                <div id="testradius" style={{ display: "none" }}>
                  <Message
                    warning
                    icon="warning circle"
                    header="Warning!"
                    content=" We are sorry you can not draw a circle with a radius greater than 5 km !"
                  />
                </div>

              </Segment>
              <br />
              <br></br>
              <div className="map-style">


                <MapWithAMarker
                  googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDIV-I4FCXCL1mlcHpVYsxC-fVX_hY-5xo&libraries=geometry,drawing,places"
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={<div style={{ height: `400px` }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                />

              </div>
              <br />
              <br />


              <Table
                hover
                responsive
                border="0"
                style={{ textAlign: this.state.isArabic ? "right" : "left" }}
              >
                <thead className="head">
                  <tr>
                    <th>
                      {this.state.isArabic ? "اسم المنطقة" : "Region Name"}
                    </th>
                    <th>
                      {this.state.isArabic
                        ? "عدد المساحات"
                        : "Number of Area Circles"}
                    </th>
                    <th>{this.state.isArabic ? "الإعدادات" : "Settings"}</th>
                  </tr>
                </thead>
                <tbody response>
                  {this.state.data.map((person) => (
                    <tr>
                      <td>{person.area_name} </td>
                      <td>{person.area.length}</td>
                      <td>


                        <Header as="h5">
                          <Icon

                            name="edit outline"
                            color="black"
                            floated={this.state.isArabic ? "left" : "right"}
                            id={person.id}
                            onClick={(event) => {
                              this.openEdit(event);
                            }}
                          />

                          <Icon

                            name="trash alternate outline"
                            color="black"
                            floated={this.state.isArabic ? "left" : "right"}
                            id={person.id}
                            onClick={(event) => {
                              this.openDelete(event);
                            }}
                          />
                        </Header>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>


              <div className="pagination">
                <Segment basic />
                <Divider horizontal>
                  <Header
                    as="h5"
                    floated={this.state.isArabic ? "left" : "right"}
                  >
                    <Pagination
                      defaultActivePage={1}
                      onPageChange={this.handlePaginationChange}
                      totalPages={this.state.totalPages}
                      className="page"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Header>
                  <Header
                    as="h5"
                    floated={this.state.isArabic ? "left" : "right"}
                  />
                </Divider>
              </div>

              <div className="searchpagination" style={{ display: "none" }}>
                <Segment basic />

                <Divider horizontal>
                  <Header
                    as="h5"
                    floated={this.state.isArabic ? "left" : "right"}
                  >
                    <Pagination
                      defaultActivePage={1}
                      onPageChange={this.handlePaginationChangeSearch}
                      totalPages={this.state.serachTotalPage}
                      className="page"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Header>
                  <Header
                    as="h5"
                    floated={this.state.isArabic ? "left" : "right"}
                  />
                </Divider>
              </div>

            </div>
          </div>

          <SemanticToastContainer />
        </div>




        <Modal
          size="small"
          className="add"
          style={modEdit}
          open={this.state.modalOpenUpload}
          onClose={this.handleCloseUpload}
        >
          <Header icon="upload" content="Upload Area" />
          <Modal.Content scrolling>
            <Form>
              <Form.Group widths="equal">
                <Form.Input
                  fluid
                  label="Please enter a region name"
                  required
                  value={this.state.areaname}
                  name="areaname"
                  onChange={(areaname) => {
                    this.setState({ areaname: areaname.target.value });
                  }}
                />
              </Form.Group>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content="Submit"
              onClick={this.circleSubmit}
            />
            <Button
              basic
              color="black"
              content="Cancel"
              onClick={this.handleCloseUpload}
            />
          </Modal.Actions>
        </Modal>


        <Modal
          size="tiny"
          className="add"
          open={this.state.modalOpenDelete}
          onClose={this.handleCloseDelete}
          size="small"
          style={this.state.isArabic ? modDeletea : modDelete}
        >
          <Header
            icon="hand point up outline"
            content={
              this.state.isArabic
                ? " حذف الدائرة المحددة "
                : "Delete Selected Circle"
            }
          />
          <Modal.Content>
            <Header as="h3" textAlign="center">
              {" "}
              {this.state.isArabic
                ? "هل انت متأكد من حذف هذه الدائرة ؟"
                : "Are you sure you want to delete this Area circle ? "}
            </Header>
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content={i18n.t("Yes.label")}
              onClick={this.handleOpenDelteUpdate}
            />
            <Button
              basic
              color="black"
              content={i18n.t("No.label")}
              onClick={this.handleCloseDelete}
            />
          </Modal.Actions>
        </Modal>



        <Modal
          size="tiny"
          className="add"
          open={this.state.modalDelete}
          onClose={this.handleOpenDelteArea}
          style={this.state.isArabic ? modDeletea : modDelete}
          floated={this.state.isArabic ? "right" : "left"}
        >
          <Header
            icon="trash alternate outline"
            content={this.state.isArabic ? "حذف المنطقة" : "Delete Region  "}
          />
          <Modal.Content>
            <Header as="h3" textAlign="center">
              {" "}
              {this.state.isArabic
                ? "هل انت متأكد من حذف هذه المنطقة  ؟"
                : "Are you sure you want to  delete this  region? "}
            </Header>
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="teal"
              content={i18n.t("delete.label")}
              onClick={() => {
                this.DeleteArea();
              }}
            />
            <Button
              basic
              color="black"
              content={i18n.t("Cancel.label")}
              onClick={() => {
                window.location = "Map";
              }}
            />
          </Modal.Actions>
        </Modal>



      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(
  mapStateToProps,
  { selectedlanguage }
)(Map);
